import axios from "../../adminCompenents/config/axiosConfig";

export async function login(email = "", password = "") {
  try {
    const response = await axios.post("/users/login", {
      email,
      password,
    });

    const userData = response.data?.user;
    console.log("userData", userData?._id);
    localStorage.setItem("userLoginRequestID", userData?._id);
    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("Login service error:", error.message);
      return {
        success: false,
        msg: "une erreur s'est produite lors de la tentative de connexion",
      };
    }
  }
}

export async function loginClient(email = "", password = "") {
  try {
    const response = await axios.post("/users/login-apprenant", {
      email,
      password,
    });

    const userData = response.data;
    console.log("loginClient response:", userData);
    localStorage.setItem("clientLoginRequestID", userData?.userId);
    localStorage.setItem("clientToken", userData?.token);
    return { success: true, msg: "", userId: userData?.userId, user: userData?.user };
  } catch (error) {
    if (error.response?.data) {
      console.error("API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("Login service error:", error.message);
      return {
        success: false,
        msg: "une erreur s'est produite lors de la tentative de connexion",
      };
    }
  }
}
// src/services/auth.js

export async function registerClient(
  email = "",
  telephone = "",
  password = ""
) {
  try {
    const response = await axios.post("/users", {
      name: email.split("@")[0], // use email prefix as name
      email,
      telephone,
      password,
      role: "client",
    });

    return { success: true, ...response.data };
  } catch (error) {
    if (error.response?.data) {
      console.error("registerClient API Error:", error.response.data);
      const { data } = error.response;
      return { success: false, msg: data.message };
    }
    console.error("registerClient API Error:", error.message);
    return {
      success: false,
      msg: "Erreur serveur. Veuillez réessayer.",
    };
  }
}

export async function VerifyCode(userId = "", code = "") {
  try {
    const response = await axios.post("/users/verify-code", {
      userId,
      code,
    });

    localStorage.removeItem("userLoginRequestID");
    console.log("response from VerifyCode", response);
    return { success: true, data: response.data?.data, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("VerifyCode API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        data: null,
        msg: data.message,
      };
    } else {
      console.error("VerifyCode API Error:", error.message);
      return {
        success: false,
        data: null,
        msg: "une erreur s'est produite lors de la tentative de connexion",
      };
    }
  }
}
export async function VerifyCodeClient(userId = "", code = "") {
  try {
    console.log("VerifyCodeClient called with userId:", userId, "code:", code);
    const response = await axios.post("/users/verify-code-apprenant", {
      userId,
      code,
    });

    localStorage.removeItem("clientLoginRequestID");

    return { success: true, data: response.data?.user, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("VerifyCode API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        data: null,
        msg: data.message,
      };
    } else {
      console.error("VerifyCode API Error:", error.message);
      return {
        success: false,
        data: null,
        msg: "une erreur s'est produite lors de la tentative de connexion",
      };
    }
  }
}

export async function requestPasswordReset(email = "") {
  try {
    const response = await axios.post("/users/request-password-reset", {
      email,
    });

    const userId = response.data?.userId;
    return { success: true, userId, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("requestPasswordReset API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("requestPasswordReset API Error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de réinitialisation de votre mot de passe. Veuillez réessayer.",
      };
    }
  }
}

export async function resetPassword(
  userId = "",
  resetPasswordCode = "",
  newPassword = ""
) {
  try {
    const response = await axios.post("/users/reset-password", {
      userId,
      resetPasswordCode,
      newPassword,
    });

    localStorage.removeItem("userResetPwdRequestID");
    localStorage.removeItem("resetPwdCode");
    return { success: true, msg: "" };
  } catch (error) {
    if (error.response?.data) {
      console.error("resetPassword API Error:", error.response.data);
      const { data } = error.response;

      return {
        success: false,
        msg: data.message,
      };
    } else {
      console.error("resetPassword API Error:", error.message);
      return {
        success: false,
        msg: "Une erreur s'est produite lors de la tentative de réinitialisation de votre mot de passe. Veuillez réessayer.",
      };
    }
  }
}

export async function getCurrentUser() {
  try {
    const response = await axios.get("/users/check-auth");
    console.log("getCurrentUser response", response);
    return response.data?.data;
  } catch (error) {
    console.error("Failed to fetch current user:", error);
    return null;
  }
}
export async function getCurrentUserClient() {
  try {
    const response = await axios.get("/users/check-auth-apprenant");
    return response.data?.user;
  } catch (error) {
    console.error("Failed to fetch current user:", error);
    return null;
  }
}
export async function logout(userId = null) {
  try {
    const response = await axios.post("/users/logout", { userId });
    return true;
  } catch (error) {
    return false;
  }
}
export async function logoutClient(userId = null) {
  try {
    const response = await axios.post("/users/logout-apprenant", { userId });
    return true;
  } catch (error) {
    return false;
  }
}
